import { createStore } from 'vuex'

// vuex模块扩展，以modules中的key做命名空间
const files = require.context('./modules', false, /\.js$/);
const modules = {}
files.keys().forEach((key) => {
	modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
})

// 启用vuex
export default createStore({
  modules
})